var _ellipse, _path, _ellipse2, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgOval = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96 80",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 48,
    cy: 40,
    fill: "#fff",
    rx: 19,
    ry: 15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48 26c9.93 0 18 6.28 18 14s-8.1 14-18 14-18-6.28-18-14 8.07-14 18-14m0-2c-11 0-20 7.16-20 16s9 16 20 16 20-7.16 20-16-8.95-16-20-16Z"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 48,
    cy: 40,
    fill: "#fff",
    rx: 18.5,
    ry: 14.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48 26c9.93 0 18 6.28 18 14s-8.1 14-18 14-18-6.28-18-14 8.07-14 18-14m0-1c-10.49 0-19 6.72-19 15s8.51 15 19 15 19-6.72 19-15-8.51-15-19-15Z"
  })));
};
export default SvgOval;